/**
 * @file
 * Colorbox creates #cboxPrevious/#cboxNext/#cboxSlideshow/#cboxClose as empty
 * buttons on init; their text is only injected when a lightbox opens, so
 * accessibility scanners flag them as empty buttons on page load. This adds
 * aria-labels so they are never empty.
 */
(function () {
  "use strict";

  var labels = {
    cboxPrevious: "Previous",
    cboxNext: "Next",
    cboxSlideshow: "Slideshow",
    cboxClose: "Close",
  };

  function setColorboxLabels() {
    Object.keys(labels).forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn && !btn.hasAttribute("aria-label")) {
        btn.setAttribute("aria-label", labels[id]);
      }
    });
  }

  // Run on every Drupal behavior attach (covers AJAX-inserted content and
  // any case where Colorbox initializes after the first attach pass).
  if (typeof window.Drupal !== "undefined") {
    window.Drupal.behaviors.umsiColorboxA11y = {
      attach: function () {
        setColorboxLabels();
      },
    };
  }

  // Safety net: also run after full page load, by which point Colorbox's
  // own DOM-ready callback has definitely created the buttons.
  if (document.readyState === "complete") {
    setColorboxLabels();
  } else {
    window.addEventListener("load", setColorboxLabels);
  }
})();
